<template>
  <!-- 直接挂 keep-alive + router-view, 不再套 transition.
       原因: Vue 2 的 <transition mode="out-in"> + <keep-alive> + 动态 :key 组合
       存在已知 caveat (切换 tab 时偶发闪烁/双重渲染). 后台仪表盘场景不需要页面级
       过渡动画, 移除后切换更脆快, 也不再闪烁.
       :key=fullPath 保留, 是为了支持 TagsView 的"刷新本页"(query 加 _t 时间戳
       强制重渲) 功能, 跟 keep-alive 一起工作没问题. -->
  <section class="app-main">
    <keep-alive :include="cachedViews">
      <router-view :key="viewKey"></router-view>
    </keep-alive>
  </section>
</template>

<script>
export default {
  name: 'AppMain',
  computed: {
    cachedViews() {
      return this.$store.getters.cachedViews
    },
    viewKey() {
      return this.$route.fullPath
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/layout/components/AppMain.vue